import React from "react";
import { StyledContainer, Title, BodyText, Overlay } from "./StyledComponents";

function Header({
    menuPageContent,
    rowData,
    oem,
    links,
    defaultFontFamily,
    dataAttributes,
    client,
}) {
    const { isMobile } = window?.window?.deviceDetect?.getWindowData() || {};
    const { menu_page_header, menu_page_body, dealer_header_image } =
        menuPageContent || {
            /* client content block override fields */
            menu_page_header: rowData?.header ?? null,
            menu_page_body: rowData?.content ?? null,
            dealer_header_image: null, // no dealer header image override
        };

    const { dealer_header_background_image } = client;

    return (
        <StyledContainer
            className="FODContentBlockContainer fod-header"
            data-testid="header_content_block_container"
            bgImage={dealer_header_background_image ?? dealer_header_image}
            defaultFontFamily={defaultFontFamily}
            mobile={isMobile}
        >
            <Overlay className="header-overlay">
                <Title
                    className="FODContentBlockTitle"
                    data-testid="header_content_block_title"
                    mobile={isMobile}
                >
                    {menu_page_header}
                </Title>
                <BodyText
                    className="FODContentBlockBodyText"
                    data-testid="header_content_block_body"
                    mobile={isMobile}
                >
                    {menu_page_body}
                </BodyText>
            </Overlay>
        </StyledContainer>
    );
}

export default Header;
